import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { Observable } from "rxjs";
import { FormControlService } from "../form-control.service";
import { ControlValueAccessorImpl } from "../ng-material-impl/control-value-accessor.impl";
import createControlValueAccessorProvider from "../utils/create-control-value-accessor-provider";


@Component({
  selector: 'ss-phone-form-control',
  templateUrl: './phone-form-control.component.html',
  styleUrls: ['./phone-form-control.component.css'],
  providers: [
    FormControlService,
    createControlValueAccessorProvider(PhoneFormControlComponent)
  ],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PhoneFormControlComponent extends ControlValueAccessorImpl<string> implements OnInit {


  inputKeyObs!: Observable<KeyboardEvent>

  constructor(
  ) {

    super()

  }

  ngOnInit(): void {

  }


}
